module.exports = __webpack_public_path__ + "img/deezer.8ffc6cf.png";